// 상담일지 등록요청 제조국 셀렉트 옵션 — 매니저어드민 utils/variables.js COUNTRY_LIST 와 동일하게 유지
export const COUNTRY_LIST = [
  "ITALY",
  "FRANCE",
  "ENGLAND",
  "GERMANY",
  "HONGKONG",
  "JAPAN",
  "POLAND",
  "PORTUGAL",
  "SCOTLAND",
  "SPAIN",
  "SRILANKA",
  "SWISS",
  "SWITZERLAN",
  "TURKEY",
  "U.S.A",
  "CHINA",
  "ROMANIA",
  "VIETNAM",
  "INDONESIA",
  "BRAZIL",
  "INDIA",
];

export const MANUFACTURER_ETC = "직접입력";
